import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Dialog, {
  DialogProps,
} from '$tablet-app/src/app/components/Dialog/Dialog';
import Text from '$tablet-app/src/app/components/Text';
import { font_variant_styles, palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC, useState } from 'react';
import styled from 'styled-components/native';
import {
  suggest_app_dialog_description,
  suggest_app_dialog_title,
} from './text';

interface Props extends DialogProps {
  onDone?: (app_name: string) => void;
}

const SuggestAppDialog: FC<Props> = (props) => {
  const [text, setText] = useState('');

  const handleClose = () => {
    setText('');
    props.onClose?.();
  };

  const handleDone = () => {
    setText('');
    props.onDone?.(text);
  };

  const can_submit = text.length > 0;

  return (
    <Dialog {...props}>
      <Body>
        <IconCircle>
          <FontAwesomeIcon
            icon="comment-lines"
            color={palette.primary_700}
            size={26}
          />
        </IconCircle>

        <Title variant="h3" weight="bold">
          {suggest_app_dialog_title}
        </Title>

        <Subtitle>{suggest_app_dialog_description}</Subtitle>

        <Input placeholder="App name" value={text} onChangeText={setText} />
      </Body>

      <Footer>
        <Button variant="text" size="large" onPress={handleClose}>
          Cancel
        </Button>

        <Button
          variant={can_submit ? 'primary' : 'secondary'}
          size="large"
          onPress={handleDone}
          disabled={!can_submit}
        >
          Send
        </Button>
      </Footer>
    </Dialog>
  );
};

const Title = styled(Text)`
  text-align: center;

  margin: 16px 0;
`;

const Subtitle = styled(Text)`
  text-align: center;

  margin-bottom: 16px;
`;

const Body = styled.View`
  align-items: center;

  border-bottom-width: 1px;
  border-bottom-color: lightgrey;

  padding: 34px;
`;

const Footer = styled.View`
  flex-direction: row;

  padding: 12.5px 16px;
`;

const Button = styled(NewButton)`
  flex: 1;
`;

const Input = styled.TextInput`
  background-color: rgba(5, 22, 51, 0.05);
  border-radius: 15px;
  text-align: center;

  width: 100%;

  ${font_variant_styles.p.semibold}
`;

const IconCircle = styled.View`
  width: 65px;
  height: 65px;

  align-items: center;
  justify-content: center;

  padding: 16px;
  background-color: rgba(83, 90, 241, 0.15);
  border-radius: 100px;
`;

export default SuggestAppDialog;
